var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBarsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2296 11V19.6148C17.2296 20.9321 18.2975 22 19.6148 22C20.9321 22 22 20.9321 22 19.6148V11V2.3852C22 1.06789 20.9321 0 19.6148 0C18.2975 0 17.2296 1.06789 17.2296 2.3852V11ZM8.6373 13.2555V19.6147C8.6373 20.9321 9.70523 22 11.0226 22C12.3395 22 13.4065 20.9315 13.4048 19.6147L13.3965 13.2666L13.3883 6.90718C13.3866 5.59377 12.3246 4.52823 11.0113 4.52207C9.70196 4.51594 8.6373 5.57561 8.6373 6.88492V13.2555ZM2.41522 13.5781C0.891216 13.5781 0.0156866 14.4682 0.00596206 15.9922C0.00245557 16.5417 0 17.1598 0 17.8177V19.6148C0 20.9321 1.06789 22 2.3852 22C3.70251 22 4.7704 20.9321 4.7704 19.6148V17.7891V15.9333C4.7704 14.6326 3.71595 13.5781 2.41522 13.5781Z",
    fill: "var(--primary-6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsFilled);
export default __webpack_public_path__ + "static/media/barsFilled.c2690681e9dd66c43f1e0ead21de9a17.svg";
export { ForwardRef as ReactComponent };